const localizers = {
  'loading.msg': () => `로드 중...`,
  'logon.message.msg': () => `인증이 필요합니다. 올바른 사용자 ID 및 암호를 입력하십시오.`,
  'logon.button.msg': () => `로그인...`,
  'SASServer.logonError.msg': () => `서버에 로그인할 수 없습니다.`,
  'SASServer.genericError.msg': () => `서버에 연결할 수 없습니다.`,
}
export default localizers;
